import { render, staticRenderFns } from "./Comingsoon-Dialog.vue?vue&type=template&id=3f1914ba"
import script from "./Comingsoon-Dialog.vue?vue&type=script&lang=js"
export * from "./Comingsoon-Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports